import { Route, Switch } from 'react-router';
import ViewMessages from './view';
import ViewThread from './thread';

const Messages = () => {
  return (
    <Switch>
      <Route exact path='/messages' component={ViewMessages} />
      <Route exact path='/messages/:id' component={ViewThread} />
    </Switch>
  );
};

export default Messages;